import React from 'react';
import { ShieldAlert, Users, FileText, AlertTriangle, Flag, ArrowLeft, Ban, CheckCircle, Mail, Phone, MapPin } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Link, useParams } from 'react-router-dom';
export function UserDetailPage() {
  const {
    id
  } = useParams();
  const navItems = [{
    label: 'Verification Queue',
    icon: FileText,
    path: '/admin',
    badge: '12'
  }, {
    label: 'User Management',
    icon: Users,
    path: '/admin/users'
  }, {
    label: 'Disputes',
    icon: Flag,
    path: '/admin/disputes'
  }, {
    label: 'Risk Analysis',
    icon: AlertTriangle,
    path: '/admin/risk'
  }];
  return <DashboardLayout title="Admin Console" personaLabel="ADMIN" personaColor="bg-red-100 text-red-800 border-red-200" navItems={navItems} userInitials="AD" data-id="element-1432">
      <div className="mb-6" data-id="element-1433">
        <Link to="/admin/users" className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#1f2933] mb-4" data-id="element-1434">
          <ArrowLeft className="w-4 h-4" data-id="element-1435" /> Back to Users
        </Link>
        <div className="flex flex-col md:flex-row justify-between items-start gap-4" data-id="element-1436">
          <div className="flex items-center gap-4" data-id="element-1437">
            <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center font-bold text-xl text-gray-600" data-id="element-1438">
              RK
            </div>
            <div data-id="element-1439">
              <h1 className="text-2xl font-bold mb-1" data-id="element-1440">Rajesh Kumar</h1>
              <div className="flex items-center gap-2" data-id="element-1441">
                <span className="px-2 py-0.5 bg-blue-100 text-blue-800 text-xs font-bold rounded" data-id="element-1442">
                  Seller
                </span>
                <span className="px-2 py-0.5 bg-green-100 text-green-800 text-xs font-bold rounded flex items-center gap-1" data-id="element-1443">
                  <CheckCircle className="w-3 h-3" data-id="element-1444" /> Verified
                </span>
              </div>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-1445">
            <button className="px-4 py-2 border border-red-300 bg-red-50 text-red-700 text-sm font-bold hover:bg-red-100 flex items-center gap-2" data-id="element-1446">
              <Ban className="w-4 h-4" data-id="element-1447" /> Suspend User
            </button>
            <button className="px-4 py-2 border border-gray-300 bg-white text-sm font-bold hover:bg-gray-50" data-id="element-1448">
              Reset Password
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1449">
        <div className="lg:col-span-2 space-y-8" data-id="element-1450">
          {/* Activity Log */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-1451">
            <h2 className="font-bold text-lg mb-6" data-id="element-1452">Recent Activity</h2>
            <div className="space-y-4" data-id="element-1453">
              {[{
              action: 'Posted new listing',
              detail: 'Premium Corner Plot',
              time: '2 days ago'
            }, {
              action: 'Replied to inquiry',
              detail: 'Message to John Doe',
              time: '3 days ago'
            }, {
              action: 'Updated profile',
              detail: 'Changed phone number',
              time: '1 week ago'
            }, {
              action: 'Account Verified',
              detail: 'KYC documents approved',
              time: '1 month ago'
            }].map((act, i) => <div key={i} className="flex justify-between items-center p-3 border-b border-gray-100 last:border-0" data-id="element-1454">
                  <div data-id="element-1455">
                    <p className="font-bold text-sm" data-id="element-1456">{act.action}</p>
                    <p className="text-xs text-gray-500" data-id="element-1457">{act.detail}</p>
                  </div>
                  <span className="text-xs text-gray-400 font-mono" data-id="element-1458">
                    {act.time}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Listings */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-1459">
            <h2 className="font-bold text-lg mb-6" data-id="element-1460">Active Listings (2)</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1461">
              {[1, 2].map(i => <div key={i} className="border border-gray-200 p-4" data-id="element-1462">
                  <div className="font-bold text-sm mb-1" data-id="element-1463">
                    Premium Corner Plot
                  </div>
                  <div className="text-xs text-gray-500 mb-2" data-id="element-1464">
                    Hinjewadi Phase 1
                  </div>
                  <Link to="/listing/1" className="text-xs font-bold text-blue-600 hover:underline" data-id="element-1465">
                    View Listing
                  </Link>
                </div>)}
            </div>
          </div>
        </div>

        <div className="space-y-6" data-id="element-1466">
          {/* Contact Info */}
          <div className="bg-white border border-gray-300 p-6" data-id="element-1467">
            <h3 className="font-bold text-sm uppercase text-gray-500 mb-4" data-id="element-1468">
              Contact Information
            </h3>
            <div className="space-y-4" data-id="element-1469">
              <div className="flex items-center gap-3" data-id="element-1470">
                <Mail className="w-4 h-4 text-gray-400" data-id="element-1471" />
                <span className="text-sm font-mono" data-id="element-1472">rajesh@example.com</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-1473">
                <Phone className="w-4 h-4 text-gray-400" data-id="element-1474" />
                <span className="text-sm font-mono" data-id="element-1475">+91 98765 43210</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-1476">
                <MapPin className="w-4 h-4 text-gray-400" data-id="element-1477" />
                <span className="text-sm" data-id="element-1478">Pune, Maharashtra</span>
              </div>
            </div>
          </div>

          {/* Risk Score */}
          <div className="bg-green-50 border border-green-200 p-6" data-id="element-1479">
            <h3 className="font-bold text-sm text-green-900 mb-2" data-id="element-1480">
              Low Risk Profile
            </h3>
            <p className="text-xs text-green-800 mb-4" data-id="element-1481">
              No flags or disputes in the last 12 months. Documents verified.
            </p>
            <div className="w-full bg-green-200 h-2 rounded-full overflow-hidden" data-id="element-1482">
              <div className="bg-green-600 h-full w-[95%]" data-id="element-1483"></div>
            </div>
            <div className="flex justify-between mt-1 text-[10px] text-green-800 font-mono" data-id="element-1484">
              <span data-id="element-1485">Score: 95/100</span>
              <span data-id="element-1486">Trust Level: High</span>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>;
}